import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * DatePicker - элмент с аттрибутом datepicker указывает на то, что будет к нему применен метод ui.datepicker
 * свойства используемые в дейтпикере (коррелирют со свойствами ui.datepicker):
 * minDate
 * maxDate
 * yearRange
 * dateFormat
 * showOtherMonths (по-умолчанию = true)
 * selectOtherMonths (по-умолчанию = true)
 * changeYear (по-умолчанию = true)
 * beforeShow
 * duration (по-умолчанию = fast)
 * inputMask
 * z-index (по-умолчанию = 1000)
 */
export class DatePickerBehaviour extends BaseEmptyPrefixControlBehaviour {
    private functions: any = {
        beforeShow: true,
        onSelect: true,
    };
    private defaults: any = {
        showOtherMonths: true,
        selectOtherMonths: true,
        changeYear: true,
        duration: 'fast',
        'z-index': 1000,
        onSelect: (text, instance) => {
            const jq: any = $;
            const input = instance.input[0];
            const form = input.form;
            const validator = jq(form).validate();
            if (validator) validator.element(input);
            if ($(input).is('[pager-trigger]')) $(input).keyup();
        },
    };
    private properties: any = {
        0: {
            mindate: 'minDate',
            maxdate: 'maxDate',
            yearrange: 'yearRange',
            dateformat: 'dateFormat',
            showothermonths: 'showOtherMonths',
            selectothermonths: 'selectOtherMonths',
            changeyear: 'changeYear',
            beforeshow: 'beforeShow',
            duration: 'duration',
            inputmask: 'inputMask',
            onselect: 'onSelect',
        },
    };

    constructor() {
        super('datepicker');
    }
    protected installCondition(element: any): boolean {
        return !!$.datepicker;
    }
    protected installBehaviour(element: HTMLElement): void {
        const dp = $(element);
        const data: any = Utils.getObjectByAttributes(
            this.tag,
            element,
            (p, l) => this.propertyTranslator(p, l),
            this.defaults
        );
        for (const key in data) {
            if (this.isFunction(key)) {
                data[key] = eval(data[key]);
            }
        }

        const beforeShow = data.beforeShow;
        data.beforeShow = function (input, instance) {
            instance.dpDiv.addClass('blockMsg');

            if (beforeShow) beforeShow.apply(this, arguments);
        };

        dp.datepicker(data);
    }

    private isFunction(property) {
        return this.functions[property];
    }

    private propertyTranslator(property: string, level: number): string {
        const levelObj = this.properties[level];
        if (levelObj) {
            const result = levelObj[property];
            if (result) return result;
        }
        return property;
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.DatePickerBehaviour = DatePickerBehaviour;